import React, { useState, useEffect, useRef, forwardRef } from "react";
import {
  Box,
  Badge,
  Stack,
  Button,
  Divider,
  IconButton,
  Typography,
  MenuItem,
  Menu,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useQuery } from "@apollo/client";
import { useReactToPrint } from 'react-to-print';
import html2canvas from "html2canvas";
import { styled } from "@mui/material/styles";
// icon
import PrintIcon from "@mui/icons-material/Print";
import { TiWarning } from "react-icons/ti";
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// src
import "./dashboard.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

import DashboardCard from "../../Components/Dashboard/DashboardCard";
import AttendancePercentage from "../../Components/Dashboard/AttendancePercentage";

// overall
import DropOutChart from "../../Components/Dashboard/DropoutChart/DropOutChart";
import TotalEnrollment from "../../Components/Dashboard/TotalEnrollmentChart/TotalEnrollment";
import RemainStudentChart from "../../Components/Dashboard/RemainStudentChart/RemainStudentChart";

// school
import DropOutChartBySchool from "../../Components/Dashboard/ChartBySchool/DropOutChartBySchool";
import TotalEnrollmentBySchool from "../../Components/Dashboard/ChartBySchool/TotalEnrollmentBySchool";
import RemainStudentChartBySchool from "../../Components/Dashboard/ChartBySchool/RemainStudentChartBySchool";

// level
import DropOutChartByLevel from "../../Components/Dashboard/ChartByLevel/DropOutChartByLevel";
import TotalEnrollmentByLevel from "../../Components/Dashboard/ChartByLevel/TotalEnrollmentByLevel";
import RemainStudentChartByLevel from "../../Components/Dashboard/ChartByLevel/RemainStudentChartByLevel";

// teacher
import DropOutChartByTeacher from "../../Components/Dashboard/ChartByTeacher/DropOutChartByTeacher";
import TotalEnrollmentByTeacher from "../../Components/Dashboard/ChartByTeacher/TotalEnrollmentByTeacher";
import RemainStudentChartByTeacher from "../../Components/Dashboard/ChartByTeacher/RemainStudentChartByTeacher";

// percentage chart
import AttendancePercentageByGroup from "../../Components/Dashboard/AttendancePercentageChart/AttendancePercentageByGroup";
import AttendancePercentageByLevel from "../../Components/Dashboard/AttendancePercentageChart/AttendancePercentageByLevel";
import AttendancePercentageBySchool from "../../Components/Dashboard/AttendancePercentageChart/AttendancePercentageBySchool";
import AttendancePercentageByClasses from "../../Components/Dashboard/AttendancePercentageChart/AttendancePercentageByClasses";

import {
  SelectSchool,
  SelectLevel,
  // SelectGroup,
  // SelectTeacher,
  SelectAcademicYear,
  SelectTeacherUserByAcademicYear
} from "../../Function/DynamicSelect";


// import DownloadComponentAsImage from "./DownloadComponentAsImage.jsx"
import {GET_NUMBER_OF_STUDENT_ATTENDANCE_PERCENTAGE_UNDER_80 } from "../../Schema/Dashboard"
import { GET_ACTIVE_ACADEMIC_YEAR } from "../../Schema/AcademicYear"

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));

export default function Dashboard() {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  let userLogin = JSON.parse(window.localStorage.getItem("logIn"));


  const componentRef = useRef(null);
  const handleDownload = async () => {
    if (!componentRef.current) return;
    const canvas = await html2canvas(componentRef.current);
    const image = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = image;
    link.download = "Dashboard-Dream-Project.png";
    link.click();
  };

  const componentRef2 = useRef(null);
  const handleDownload2 = async () => {
    if (!componentRef2.current) return;
    const canvas = await html2canvas(componentRef2.current);
    const image = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = image;
    link.download = "component.png";
    link.click();
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Dashboard-Dream-Project-pdf"
  });


  const [levelVal, setLevelVal] = useState({ id: null, title: "" });
  const [groupVal, setGroupVal] = useState({ id: null, title: "" });
  const [schoolVal, setSchoolVal] = useState({ id: null, title: "" });
  const [teacherVal, setTeacherVal] = useState({ id: null, title: "" });
  const [academicYearVal, setAcademicYearVal] = useState({ id: null, title: "", });

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (userLogin?.role === "Teacher") {
      setTeacherVal({ id: userLogin?._id, title: language === "en" ? userLogin?.latin_name : userLogin?.last_name + " " + userLogin?.first_name })
    }
  }, [language])

  const { refetch: refetchAcademic } = useQuery(GET_ACTIVE_ACADEMIC_YEAR, {
    onCompleted: ({ getActiveAcademicYear }) => {
      setAcademicYearVal({
        id: getActiveAcademicYear?._id,
        title: getActiveAcademicYear?.academic_year
      });
    },
  });

  const { data: under80Percen } = useQuery(GET_NUMBER_OF_STUDENT_ATTENDANCE_PERCENTAGE_UNDER_80, {
    variables: {
      academicYearId: academicYearVal?.id ?? null,
    },
  });
  

  const [openAtt, setOpenAtt] = useState(false)
  const handleOpenAtt = () => setOpenAtt(true)
  const handleCloseAtt = () => setOpenAtt(false)


  useEffect(() => { refetchAcademic() }, [])

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  return ( 
    <div className="dashboard-page">
      <Stack direction="column">
        <Stack direction="row" spacing={2} className="page-header">
          <Stack direction="column" justifyContent="center">
            <Box className="slash" />
          </Stack>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems={`center`}
          >
            <Typography
              className={language === "kh" ? "page-title-kh" : "page-title"}
            >
              {t(`page-dashboard`)}
            </Typography>
          </Stack>
        </Stack>
        <Stack mt={2}>
          <Divider />
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Box className="dashboard-container">
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12 }} mt={2}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 2 }}>
                  <Typography
                    className={
                      language === "kh" ? "header-text-kh" : "header-text"
                    }
                  >
                    {t(`academic_year`)}
                  </Typography>
                  <SelectAcademicYear
                    selectedVal={academicYearVal}
                    setSelectedVal={setAcademicYearVal}
                    className="search-field"
                    setLoading={setLoading}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 2 }}>
                  <Typography
                    className={
                      language === "kh" ? "header-text-kh" : "header-text"
                    }
                  >
                    {t(`school`)}
                  </Typography>
                  <SelectSchool
                    selectedVal={schoolVal}
                    setSelectedVal={setSchoolVal}
                    className="search-field"
                    // disabled={academicYearVal?.id ? false : true}
                    disabled={!academicYearVal?.id || userLogin?.role === "Teacher"}
                    setLoading={setLoading}
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 2 }}>
                  <Typography
                    className={
                      language === "kh" ? "header-text-kh" : "header-text"
                    }
                  >
                    {t(`grade_level`)}
                  </Typography>
                  <SelectLevel
                    selectedVal={levelVal}
                    setSelectedVal={setLevelVal}
                    className="search-field"
                    // disabled={academicYearVal?.id && schoolVal?.id ? false : true}
                    setLoading={setLoading}
                    disabled={!academicYearVal?.id && !schoolVal?.id || userLogin?.role === "Teacher"}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 2 }}>
                  <Typography
                    className={
                      language === "kh" ? "header-text-kh" : "header-text"
                    }
                  >
                    {t(`teacher`)}
                  </Typography>
                  <SelectTeacherUserByAcademicYear
                    selectedVal={teacherVal}
                    setSelectedVal={setTeacherVal}
                    className="search-field"
                    academicYearId={academicYearVal?.id}
                    schoolId={schoolVal?.id}
                    setLoading={setLoading}
                    disabled={userLogin?.role === "Teacher" ? true : false}
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 3 }}>
                  <Stack direction="row" justifyContent="right" mt={2.8}>
                    {
                      under80Percen?.getNumberOfStudentAttendanceLessThan80Percentage > 1 ? (                        
                      <IconButton onClick={handleOpenAtt}>
                          <Badge badgeContent={under80Percen?.getNumberOfStudentAttendanceLessThan80Percentage}
                            sx={{ "& .MuiBadge-badge": { backgroundColor: "#ff0000", color: "white" } }}
                          >
                            <TiWarning style={{ color: "#ff9300", fontSize: "28px" }} />
                          </Badge>
                        </IconButton> 
                      ) :  ""
                    } 
                  </Stack>
                </Grid>

                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 1 }}>
                  <Stack direction="row" justifyContent="right">
                    <Button
                      id="demo-customized-button"
                      aria-controls={open ? "demo-customized-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      variant="contained"
                      disableElevation
                      onClick={handleClick}
                      className="btn-create-style"
                      endIcon={<KeyboardArrowDownIcon />}
                    >
                      {t("btn-download")}
                    </Button>
                  </Stack> 
                  <StyledMenu
                    id="demo-customized-menu"
                    MenuListProps={{
                      "aria-labelledby": "demo-customized-button",
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                  >

                    <MenuItem
                      onClick={() => {
                        handleDownload();
                        handleClose();
                      }}
                      disableRipple
                      className="student-menu-item"
                    >
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        justifyContent="center"
                      >
                        <DownloadRoundedIcon className="icon" />
                        <Typography
                          className={language === "en" ? "action-txt" : "action-txt-kh"}
                        >
                          {t("img")}
                        </Typography>
                      </Stack>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handlePrint();
                        handleClose();
                      }}
                      disableRipple
                      className="student-menu-item"
                    >
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        justifyContent="center"
                      >
                        <PrintIcon className="icon" />
                        <Typography
                          className={language === "en" ? "action-txt" : "action-txt-kh"}
                        >
                          {t("pdf")}
                        </Typography>
                      </Stack>
                    </MenuItem>
                  </StyledMenu>
                </Grid>

              </Grid>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <DashboardCard
                academicYearId={academicYearVal?.id}
                schoolId={schoolVal?.id}
                levelID={levelVal?.id}
                groupID={groupVal?.id}
                teacherId={teacherVal?.id}
              />
            </Grid>
          </Grid>
        </Box>


        <Box sx={{ marginTop: "10px", }} ref={componentRef}>
          <Grid container spacing={3}>

            <Grid size={{ xs: 12 }}  >
              <Box width="100%">

                {
                  teacherVal?.id ? <TotalEnrollmentByTeacher academicYearId={academicYearVal?.id} schoolId={schoolVal?.id} teacherId={teacherVal?.id} teacherName={teacherVal?.title} />
                    : levelVal?.id && schoolVal?.id ? <TotalEnrollmentByLevel academicYearId={academicYearVal?.id} schoolId={schoolVal?.id} levelId={levelVal?.id} levelName={levelVal?.title} />
                      : schoolVal?.id ? <TotalEnrollmentBySchool schoolId={schoolVal?.id} schoolName={schoolVal?.title} academicYearId={academicYearVal?.id} />
                        : <TotalEnrollment academicYearId={academicYearVal?.id} academicYearName={academicYearVal?.title} />
                }
              </Box>
            </Grid>

            <Grid size={{ xs: 12 }}  >
              <Box width="100%">
                {
                  teacherVal?.id ? <DropOutChartByTeacher academicYearId={academicYearVal?.id} schoolId={schoolVal?.id} teacherId={teacherVal?.id} teacherName={teacherVal?.title} /> :
                    levelVal?.id && schoolVal?.id ? <DropOutChartByLevel academicYearId={academicYearVal?.id} schoolId={schoolVal?.id} levelId={levelVal?.id} levelName={levelVal?.title} />
                      : schoolVal?.id ? <DropOutChartBySchool academicYearId={academicYearVal?.id} schoolId={schoolVal?.id} schoolName={schoolVal?.title} />
                        : <DropOutChart academicYearId={academicYearVal?.id} academicYearName={academicYearVal?.title} />
                }
              </Box>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <Box width="100%">
                {
                  teacherVal?.id ? <RemainStudentChartByTeacher academicYearId={academicYearVal?.id} schoolId={schoolVal?.id} teacherId={teacherVal?.id} teacherName={teacherVal?.title} />
                    : levelVal?.id && schoolVal?.id ? <RemainStudentChartByLevel academicYearId={academicYearVal?.id} schoolId={schoolVal?.id} levelId={levelVal?.id} levelName={levelVal?.title} />
                      : schoolVal?.id ? <RemainStudentChartBySchool academicYearId={academicYearVal?.id} schoolId={schoolVal?.id} schoolName={schoolVal?.title} />
                        : <RemainStudentChart academicYearId={academicYearVal?.id} academicYearName={academicYearVal?.title} />
                }
              </Box>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <Box width="100%">
                <AttendancePercentageBySchool academicYearId={academicYearVal?.id} academicYearName={academicYearVal?.title} />
              </Box>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <Box width="100%">
                <AttendancePercentageByLevel academicYearId={academicYearVal?.id} schoolId={schoolVal?.id} schoolName={schoolVal?.title} />
              </Box>
            </Grid>

            {
              teacherVal?.id || levelVal?.id ? (
                <Grid size={{ xs: 12 }}>
                  <Box width="100%">
                    {
                      teacherVal?.id ? <AttendancePercentageByClasses academicYearId={academicYearVal?.id} schoolId={schoolVal?.id} teacherId={teacherVal?.id} teacherName={teacherVal?.title} />
                        : <AttendancePercentageByGroup academicYearId={academicYearVal?.id} schoolId={schoolVal?.id} levelId={levelVal?.id} levelName={levelVal?.title} />
                    }
                  </Box>
                </Grid>
              ) : (<Box></Box>)
            }


          </Grid>
        </Box>

      </Box>
    
      {openAtt && (<AttendancePercentage open={openAtt} handleClose={handleCloseAtt} activeAcademicYearVal={academicYearVal} />)}


    </div>
  )
}
